/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Stats_CreatedInputs */

const fr_week_session_stats_created = /** @type {(inputs: Week_Session_Stats_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaines créées`)
};

/**

* @param {Week_Session_Stats_CreatedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_stats_created = /** @type {((inputs?: Week_Session_Stats_CreatedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Stats_CreatedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_stats_created(inputs)
});